import React from 'react'
import { Button } from 'reactstrap';

const FilterDropdown = ({ isDropdownOpen, setIsDropdownOpen, onClickAllLeadDelete, handleAllEditLeadClick, checkOpen, handleSearchChange, searchTerm,
    selectedOptions, setSelectedOptions }) => {

    const options = [
        { label: "First Name", key: "firstName" },
        { label: "Last Name", key: "lastName" },
        { label: "Contact Number", key: "phone" },
        { label: "Email Address", key: "email" },
        { label: "Company Name", key: "companyName" },
        { label: "Created Date", key: "createdAt" },
        { label: "Country", key: "country" },
        { label: "State", key: "state" },
        { label: "City", key: "city" },
        { label: "Postal Code", key: "pincode" },
        { label: "Source", key: "source" },
        { label: "Deal Amount", key: "dealAmount" },
        { label: "Assigned To", key: "assignedTo" },
        { label: "Lead Status", key: "status" }

    ];

    const filteredOptions = options.filter((option) =>
        option.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleCheckboxChange = (option) => {
        setSelectedOptions((prev) =>
            prev.includes(option.key)
                ? prev.filter((key) => key !== option.key)
                : [...prev, option.key]
        );
    };



    return (
        <div>
            <div
                className="sn-add-import-lead-filter-button"
                style={{ position: "relative", display: "inline-flex" }}
            >
                <Button className="btn btn-danger" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                    <i className="ri-filter-line"></i>
                </Button>&nbsp;
                {checkOpen &&
                    <>
                        <Button className="btn btn-danger ml-1 sn-table-edit-button-main" onClick={() => handleAllEditLeadClick()}>Edit</Button> &nbsp;&nbsp;
                        <Button className="btn btn-outline-danger text-danger bg-white" onClick={() => onClickAllLeadDelete()}>Delete</Button>
                    </>
                }

                {isDropdownOpen && (
                    <div
                        className="sn-add-import-filter"
                        style={{
                            position: "absolute",
                            top: "100%",
                            right: "0",
                            zIndex: 1000,
                            backgroundColor: "#fff",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            padding: "10px",
                            boxShadow: "0 2px 5px rgba(0,0,0,0.2)",

                        }}
                    >
                        {/* Search Input */}
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                            style={{
                                width: "100%",
                                padding: "5px",
                                marginBottom: "10px",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                            }}
                        />
                        <div className='sn-sales-ninja-tble-filter-sea'>
                            {filteredOptions.map((option, index) => (
                                <div key={index} className="flex items-center mb-2">
                                    <input
                                        type="checkbox"
                                        id={`checkbox-${option.key}`}
                                        checked={selectedOptions.includes(option.key)}
                                        onChange={() => handleCheckboxChange(option)}
                                        className="mr-2"
                                    />&nbsp;
                                    <label
                                        htmlFor={`checkbox-${option.key}`}
                                        className="text-gray-700"
                                    >
                                        {option.label}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default FilterDropdown
